import Spinner from "./spinner.component.js";

export default angular
    .module("oui.spinner", [])
    .component("ouiSpinner", Spinner)
    .name;
